/**
 * North Star Decision Intelligence OS
 * React Application Entry Point
 *
 * Phase 2B Day 4 Milestone 2
 * RESTORED: StrictMode re-enabled for development bug detection
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
